import { render, staticRenderFns } from "./goodsGroupList.vue?vue&type=template&id=374830c8&scoped=true&"
import script from "./goodsGroupList.vue?vue&type=script&lang=js&"
export * from "./goodsGroupList.vue?vue&type=script&lang=js&"
import style0 from "./goodsGroupList.vue?vue&type=style&index=0&id=374830c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374830c8",
  null
  
)

component.options.__file = "goodsGroupList.vue"
export default component.exports